/**
 * RdSAP API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * The state the lodgement is in. This is a calculated value and can not be updated directly.
 */
export type ReportStatus = 'IN-PROGRESS' | 'CALCULATED' | 'COMPLETED' | 'LODGED' | 'FINALISED' | 'CANCELLED';

export const ReportStatus = {
    InProgress: 'IN-PROGRESS' as ReportStatus,
    Calculated: 'CALCULATED' as ReportStatus,
    Completed: 'COMPLETED' as ReportStatus,
    Lodged: 'LODGED' as ReportStatus,
    Finalised: 'FINALISED' as ReportStatus,
    Cancelled: 'CANCELLED' as ReportStatus
};

